import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import ButtonPurple from 'components/design/Form/ButtonPurple'

const ModalSlackConnect = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const handleConnectSlack = () => {
    dispatch({
      type: 'apps/CALL_SLACK_SUPPORT_MANUAL_INTENT',
    })
    handleCancel()
  }

  const { visibleModalID } = settings
  const modalID = 'slackConnect'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="slack_connect_modal"
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
    >
      <>
        <div className="slack-modal-content">
          <div className="slack-icon-wrapper">
            <div className="slack-icon" />
          </div>
          <div className="slack-modal-title">Slack Support</div>
          <div className="slack-modal-subtitle">
            Set up your slack channel and get personalized integration support from CometChat
            engineers.
          </div>
        </div>
        <ButtonPurple
          holderStyles={{ width: '100%' }}
          buttonStyles={{ width: '100%' }}
          onClick={handleConnectSlack}
          buttonText="Get now for free"
        />
      </>
    </Modal>
  )
}

export default ModalSlackConnect
